import { render, staticRenderFns } from "./compareFacilities.vue?vue&type=template&id=baefb52a&scoped=true"
import script from "./compareFacilities.vue?vue&type=script&lang=js"
export * from "./compareFacilities.vue?vue&type=script&lang=js"
import style0 from "./compareFacilities.vue?vue&type=style&index=0&id=baefb52a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baefb52a",
  null
  
)

export default component.exports